import React from 'react';
import { useTranslation } from 'react-i18next';
import { CatalogSkeleton } from '../CatalogSkeleton/CatalogSkeleton';
import { ConnectedSkeleton } from '../ConnectedSkeleton/ConnectedSkeleton';
import { SkillToolsSkeleton } from '../SkillToolsSkeleton/SkillToolsSkeleton';
import { NS } from '../i18n';
import type { IntegrationsSkeletonKind } from '../integrationsSkeletonKind';
import './TabSkeleton.css';

export interface TabSkeletonProps {
  kind: IntegrationsSkeletonKind;
}

/**
 * A tab's content while it loads: Connected and the catalog, or Skill tools. The layout draws it
 * alone while a tab's chunk loads, so the header and the tabs stay; PageSkeleton draws it inside
 * the whole page. The page's one live region: no `aria-busy`, which holds the announcement back.
 */
export function TabSkeleton({ kind }: TabSkeletonProps): React.ReactElement {
  const { t } = useTranslation(NS);
  return (
    <div className="integrations-tab-skeleton" role="status">
      <span className="integrations-tab-skeleton__sr-only">{t(kind)}</span>
      {kind === 'providers' ? (
        <div className="integrations-tab-skeleton__body" aria-hidden="true">
          <ConnectedSkeleton />
          <span className="integrations-tab-skeleton__divider" />
          <CatalogSkeleton />
        </div>
      ) : (
        <div className="integrations-tab-skeleton__body" aria-hidden="true">
          <SkillToolsSkeleton />
        </div>
      )}
    </div>
  );
}
